// ── KP Strategy site configuration ──────────────────────────────
// Swap the Calendly URL here — every "Book an Intro Call" CTA uses this.
export const CALENDLY_URL = "https://calendly.com/kristelprocida";

export const CONTACT_EMAIL = "kpstrategyteam@gmail.com";

// PLACEHOLDER — replace with the real Tally assessment URL once created.
// Every "Take the Free Assessment" CTA uses this single config point.
export const ASSESSMENT_URL = "https://tally.so/r/REPLACE-WITH-KP-ASSESSMENT";

export const NAV_LINKS = [
  { label: "How It Works", to: "/how-it-works", testid: "nav-link-how-it-works" },
  { label: "Who I Help", hash: "#who-i-help", testid: "nav-link-who-i-help" },
  { label: "Services", to: "/services", testid: "nav-link-services" },
  { label: "Workshops", to: "/workshops", testid: "nav-link-workshops" },
  { label: "OS", to: "/os", testid: "nav-link-os" },
  { label: "About", hash: "#about", testid: "nav-link-about" },
];
